if(!customElements.get('pdp-smp')){
  customElements.define(
    'pdp-smp',
    class SMP extends HTMLElement {
      constructor() {
        super();

        this.buttons.forEach((button) => button.addEventListener('click', this.handleButtonClick.bind(this)));
      }

      get buttons() {
        return this._buttons = this._buttons || Array.from(this.querySelectorAll('.js-smp-btn'));
      }

      refreshStoreProduct(link){
        const SMP_SECTIONS = document.querySelectorAll('[id*="__main-product"]')[0]

        if ($(SMP_SECTIONS).length > 0) {
          const section_ids = []
          // get section ids
          $(SMP_SECTIONS).each(function (i, item) {
            const sectionId = item.id.replace('shopify-section-', '')
            section_ids.push(sectionId)
          })

          Promise.all(section_ids.map((sectionId) => {
            return new Promise((resolve) => {
              const newUrl = link + `?section_id=` + sectionId
              window
              .fetch(newUrl)
              .then()
              .then((_) => _.text())
              .then((html) => {
                // Parse the HTML string into a document
                const parser = new DOMParser();
                const doc = parser.parseFromString(html, 'text/html');

                // Get the new section (without executing <script> tags again)
                const newSection = doc.querySelector('#shopify-section-' + sectionId);

                if (newSection) {
                  const sectionElement = document.querySelector('#shopify-section-' + sectionId);
                  sectionElement.replaceWith(newSection);
                }
              })
              .then((_) => {
                resolve(true)
              })
              .catch((err) => {
                resolve(true)
                console.log(err)
              })
            })
          })).then((_) => {
            // reinit ReelUp
            if (window.REELUP && typeof window.REELUP.initCarousel === "function") {
              window.REELUP.initCarousel()
            }
            // reinit reviews
            ratingSnippet("ruk_rating_snippet", {
              store: "astropet.de",
              mode: "default",
              color: "#F1C005",
              linebreak: false,
              text: "Bewertungen",
              singularText: "Bewertung",
              lang: "en",
              usePolaris: false,
              showEmptyStars: false,
            });
          })
        }
      }

      handleButtonClick(event) {
        const target = event.target
        const handle = target.getAttribute('data-href')

        window.history.replaceState({}, '', handle)

        new Promise(() => {
          this.refreshStoreProduct(handle)
        }).catch((err) => {
          console.log(err)
        })
      }
    }
  )
}